export default {
  data() {
    return {
      allStores: [],
      radius: 40,
      queryPlace: null,
    }
  },
  computed: {
    filteredList() {
      let self = this;
      let results;
      if(this.queryPlace) {
        results = this.allStores.filter(store => {
          return self.harvesine(
            {
              lng: self.queryPlace.geometry.location.lng(),
              lat: self.queryPlace.geometry.location.lat()
            },
            {
              lng: store.position.coordinates[0],
              lat: store.position.coordinates[1]
            }) < self.radius;
        });
      } else {
        results = self.allStores;
      }
      this.$root.$emit('rubinred.store-locator.search.completed', results.length);
      return results;
    }
  },
  methods: {
    harvesine(p1, p2) {

      function toRad(x) {
        return x * Math.PI / 180;
      }

      var lon1 = p1.lng;
      var lat1 = p1.lat;

      var lon2 = p2.lng;
      var lat2 = p2.lat;

      var R = 6371; // km

      var x1 = lat2 - lat1;
      var dLat = toRad(x1);
      var x2 = lon2 - lon1;
      var dLon = toRad(x2)
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c;

      return d;
    },
  }
}


// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/extensions/rubinred/store-locator/assets/js/mixins/StoreLocator.js